import {
  Activity,
  Angry,
  BadgeAlert,
  BadgeCheck,
  Baby,
  Brain,
  BrainCog,
  BriefcaseBusiness,
  CigaretteOff,
  CircleDotDashed,
  Cloud,
  CloudRain,
  Dice5,
  DoorOpen,
  Eye,
  EyeClosed,
  Flame,
  Flower2,
  Focus,
  Gauge,
  GitFork,
  GraduationCap,
  Hand,
  HandHeart,
  Heart,
  HeartCrack,
  HeartPulse,
  Languages,
  Link,
  Link2Off,
  Map,
  MessageCircle,
  MessageCircleWarning,
  Moon,
  PawPrint,
  Plane,
  Puzzle,
  Rainbow,
  Repeat2,
  Route,
  ScanFace,
  Scale,
  Shield,
  ShieldAlert,
  ShieldPlus,
  Shapes,
  Smartphone,
  Sparkles,
  Sprout,
  Stethoscope,
  Timer,
  Unlink,
  UserRound,
  UserRoundX,
  Users,
  UsersRound,
  Utensils,
  WalletCards,
  WineOff,
  Wind,
  Zap,
  type LucideIcon,
} from "lucide-react";
import type { SpecialtyIconId } from "~/lib/therapy-specialties";

const specialtyIcons: Record<SpecialtyIconId, LucideIcon> = {
  activity: Activity,
  angry: Angry,
  "badge-alert": BadgeAlert,
  "badge-check": BadgeCheck,
  baby: Baby,
  brain: Brain,
  "brain-cog": BrainCog,
  "briefcase-business": BriefcaseBusiness,
  "cigarette-off": CigaretteOff,
  "circle-dot-dashed": CircleDotDashed,
  cloud: Cloud,
  "cloud-rain": CloudRain,
  "dice-5": Dice5,
  "door-open": DoorOpen,
  eye: Eye,
  "eye-closed": EyeClosed,
  flame: Flame,
  "flower-2": Flower2,
  focus: Focus,
  gauge: Gauge,
  "git-fork": GitFork,
  "graduation-cap": GraduationCap,
  hand: Hand,
  "hand-heart": HandHeart,
  heart: Heart,
  "heart-crack": HeartCrack,
  "heart-pulse": HeartPulse,
  languages: Languages,
  link: Link,
  "link-2-off": Link2Off,
  map: Map,
  "message-circle": MessageCircle,
  "message-circle-warning": MessageCircleWarning,
  moon: Moon,
  "paw-print": PawPrint,
  plane: Plane,
  puzzle: Puzzle,
  rainbow: Rainbow,
  "repeat-2": Repeat2,
  route: Route,
  "scan-face": ScanFace,
  scale: Scale,
  shield: Shield,
  "shield-alert": ShieldAlert,
  "shield-plus": ShieldPlus,
  shapes: Shapes,
  smartphone: Smartphone,
  sprout: Sprout,
  stethoscope: Stethoscope,
  timer: Timer,
  unlink: Unlink,
  "user-round": UserRound,
  "user-round-x": UserRoundX,
  users: Users,
  "users-round": UsersRound,
  utensils: Utensils,
  "wallet-cards": WalletCards,
  "wine-off": WineOff,
  wind: Wind,
  zap: Zap,
};

export function getSpecialtyIcon(iconId?: SpecialtyIconId): LucideIcon {
  return iconId ? specialtyIcons[iconId] : Sparkles;
}
